import React, { useMemo } from 'react';
import { useProcessArchs } from './archUtils';

// 加工模式组「适用框架」(2026-10-22): 取代写死在前端的加工头类型 (LASER/KNIFE/...).
// 选项与显示名一律来自工艺框架注册表 (process_arch), 新增机器类型登记框架即可选, 不改代码.

/** 适用框架标签 (只读); 空 = 不限框架. */
export function ArchTags({ codes }: { codes?: string[] | null }) {
    const archs = useProcessArchs();
    const labelOf = useMemo(() => new Map(archs.map((a) => [a.code, a.label])), [archs]);
    if (!codes || codes.length === 0) {
        return <span className="tag bg-slate-100 text-slate-400 text-[10px]">不限框架</span>;
    }
    return (
        <>
            {codes.map((c) => (
                <span key={c} className="tag bg-slate-100 text-slate-500 text-[10px]">
                    {labelOf.get(c) || c}
                </span>
            ))}
        </>
    );
}

/** 适用框架多选 (勾选块): 选项只列启用的框架; 已选但已停用/已删的编码仍列出, 便于取消. */
export function ArchMultiPick({
    value,
    onChange,
}: {
    value?: string[] | null;
    onChange: (next: string[]) => void;
}) {
    const archs = useProcessArchs(true);
    const all = useProcessArchs();
    const labelOf = useMemo(() => new Map(all.map((a) => [a.code, a.label])), [all]);
    const selected = value || [];
    const extra = selected.filter((c) => !archs.some((a) => a.code === c));
    const toggle = (code: string) =>
        onChange(selected.includes(code) ? selected.filter((c) => c !== code) : [...selected, code]);
    return (
        <div className="flex flex-wrap gap-2">
            {[...archs.map((a) => ({ code: a.code, label: `${a.icon || ''} ${a.label}`.trim() })),
                ...extra.map((c) => ({ code: c, label: `${labelOf.get(c) || c} (未启用)` }))].map((o) => {
                const on = selected.includes(o.code);
                return (
                    <button
                        key={o.code}
                        type="button"
                        className={`px-2.5 py-1 rounded border text-xs ${
                            on
                                ? 'bg-brand-50 border-brand-400 text-brand-700'
                                : 'bg-white border-slate-200 text-slate-600 hover:border-slate-300'
                        }`}
                        onClick={() => toggle(o.code)}
                    >
                        {on ? '✓ ' : ''}
                        {o.label}
                    </button>
                );
            })}
        </div>
    );
}
